//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopScreen from '~/components/TopScreen.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import DescriptionCard from '~/components/forGaming/DescriptionCard.vue'

export default {
  components: {
    TopScreen,
    FooterTop,
    DescriptionCard
  },
  data () {
    return {
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : null,
      isLargeScreen: typeof window !== 'undefined' ? window.matchMedia('(min-width: 1024px)').matches : null,
      mobileActive: [true],
      activeItem: 0,
      hide: false,
      items: [
        {
          link: '/markets/brazil',
          linkText: 'cross-border.block2.link-text1',
          name: 'cross-border.block2.item1',
          img: require('@/assets/img/products-services/cross-border/0.png'),
          row1: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/diner.svg'),
              require('@/assets/img/products-services/cross-border/payments/elo.svg'),
              require('@/assets/img/products-services/cross-border/payments/amer.svg'),
              require('@/assets/img/products-services/cross-border/payments/mast.svg'),
              require('@/assets/img/products-services/cross-border/payments/visa.svg'),
              require('@/assets/img/products-services/cross-border/payments/hiper.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row2: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/elo.svg'),
              require('@/assets/img/products-services/cross-border/payments/mast.svg'),
              require('@/assets/img/products-services/cross-border/payments/visa.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row3: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/boleto.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row4: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/mer.svg'),
              require('@/assets/img/products-services/cross-border/payments/paypal.svg'),
              require('@/assets/img/products-services/cross-border/payments/picpay.svg')
            ],
            available: true,
            local: false,
            international: true
          },
          row5: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/pix.svg')
            ],
            available: true,
            local: false,
            international: true
          }
        },
        {
          link: '/markets/mexico',
          linkText: 'cross-border.block2.link-text2',
          name: 'cross-border.block2.item2',
          img: require('@/assets/img/products-services/cross-border/1.png'),
          row1: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/amer.svg'),
              require('@/assets/img/products-services/cross-border/payments/mast.svg'),
              require('@/assets/img/products-services/cross-border/payments/visa.svg'),
              require('@/assets/img/products-services/cross-border/payments/carnet.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row2: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/mast.svg'),
              require('@/assets/img/products-services/cross-border/payments/visa.svg'),
              require('@/assets/img/products-services/cross-border/payments/bbva.svg'),
              require('@/assets/img/products-services/cross-border/payments/santander.svg'),
              require('@/assets/img/products-services/cross-border/payments/hsbc.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row3: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/oxxo.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row4: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/tod.svg')
            ],
            available: true,
            local: false,
            international: true
          },
          row5: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/spei.svg')
            ],
            available: true,
            local: true,
            international: true
          }
        },
        {
          link: '/markets/chile',
          linkText: 'cross-border.block2.link-text4',
          name: 'cross-border.block2.item3',
          img: require('@/assets/img/products-services/cross-border/2.png'),
          row1: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/diner.svg'),
              require('@/assets/img/products-services/cross-border/payments/amer.svg'),
              require('@/assets/img/products-services/cross-border/payments/mast.svg'),
              require('@/assets/img/products-services/cross-border/payments/visa.svg'),
              require('@/assets/img/products-services/cross-border/payments/hiper.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row2: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/maestro.svg'),
              require('@/assets/img/products-services/cross-border/payments/visa.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row3: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/senc.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row4: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/mach.png'),
              require('@/assets/img/products-services/cross-border/payments/vita.svg')
            ],
            available: true,
            local: false,
            international: true
          },
          row5: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/khipu.svg')
            ],
            available: true,
            local: false,
            international: true
          }
        },
        {
          link: '/markets/colombia',
          linkText: 'cross-border.block2.link-text3',
          name: 'cross-border.block2.item4',
          img: require('@/assets/img/products-services/cross-border/3.png'),
          row1: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/diner.svg'),
              require('@/assets/img/products-services/cross-border/payments/amer.svg'),
              require('@/assets/img/products-services/cross-border/payments/mast.svg'),
              require('@/assets/img/products-services/cross-border/payments/visa.svg'),
              require('@/assets/img/products-services/cross-border/payments/hiper.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row2: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/elo.svg'),
              require('@/assets/img/products-services/cross-border/payments/mast.svg'),
              require('@/assets/img/products-services/cross-border/payments/visa.svg'),
              require('@/assets/img/products-services/cross-border/payments/diner.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row3: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg'),
              require('@/assets/img/products-services/cross-border/payments/baloto.svg'),
              require('@/assets/img/products-services/cross-border/payments/pmi.svg'),
              require('@/assets/img/products-services/cross-border/payments/efecty.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row4: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/tpaga.svg')
            ],
            available: true,
            local: false,
            international: true
          },
          row5: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/pse.svg')
            ],
            available: true,
            local: false,
            international: true
          }
        },
        {
          link: '/markets/peru',
          linkText: 'cross-border.block2.link-text5',
          name: 'cross-border.block2.item5',
          img: require('@/assets/img/products-services/cross-border/4.png'),
          row1: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/diner.svg'),
              require('@/assets/img/products-services/cross-border/payments/elo.svg'),
              require('@/assets/img/products-services/cross-border/payments/amer.svg'),
              require('@/assets/img/products-services/cross-border/payments/mast.svg'),
              require('@/assets/img/products-services/cross-border/payments/visa.svg'),
              require('@/assets/img/products-services/cross-border/payments/hiper.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row2: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/elo.svg'),
              require('@/assets/img/products-services/cross-border/payments/mast.svg'),
              require('@/assets/img/products-services/cross-border/payments/visa.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row3: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row4: {
            available: false
          },
          row5: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg')
            ],
            available: true,
            local: false,
            international: true
          }
        },
        {
          link: '/markets/ecuador',
          linkText: 'cross-border.block2.link-text6',
          name: 'cross-border.block2.item6',
          img: require('@/assets/img/products-services/cross-border/5.png'),
          row1: {
            available: false
          },
          row2: {
            available: false
          },
          row3: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg')
            ],
            available: true,
            local: true,
            international: true
          },
          row4: {
            available: false
          },
          row5: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg')
            ],
            available: true,
            local: true,
            international: true
          }
        },
        {
          link: '/markets/central-america',
          linkText: 'cross-border.block2.link-text7',
          name: 'cross-border.block2.item7',
          img: require('@/assets/img/products-services/cross-border/6.png'),
          row1: {
            available: false
          },
          row2: {
            available: false
          },
          row3: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg')
            ],
            available: true,
            local: false,
            international: true
          },
          row4: {
            available: false
          },
          row5: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg')
            ],
            available: true,
            local: false,
            international: true
          }
        },
        {
          link: '/markets/central-america',
          linkText: 'cross-border.block2.link-text7',
          name: 'cross-border.block2.item8',
          img: require('@/assets/img/products-services/cross-border/7.png'),
          row1: {
            available: false
          },
          row2: {
            available: false
          },
          row3: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg')
            ],
            available: true,
            local: false,
            international: true
          },
          row4: {
            available: false
          },
          row5: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg')
            ],
            available: true,
            local: false,
            international: true
          }
        },
        {
          link: '/markets/central-america',
          linkText: 'cross-border.block2.link-text7',
          name: 'cross-border.block2.item9',
          img: require('@/assets/img/products-services/cross-border/8.png'),
          row1: {
            available: false
          },
          row2: {
            available: false
          },
          row3: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg')
            ],
            available: true,
            local: false,
            international: true
          },
          row4: {
            available: false
          },
          row5: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg')
            ],
            available: true,
            local: false,
            international: true
          }
        },
        {
          link: '/markets/central-america',
          linkText: 'cross-border.block2.link-text7',
          name: 'cross-border.block2.item10',
          img: require('@/assets/img/products-services/cross-border/9.png'),
          row1: {
            available: false
          },
          row2: {
            available: false
          },
          row3: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg')
            ],
            available: true,
            local: false,
            international: true
          },
          row4: {
            available: false
          },
          row5: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg')
            ],
            available: true,
            local: false,
            international: true
          }
        },
        {
          link: '/markets/central-america',
          linkText: 'cross-border.block2.link-text7',
          name: 'cross-border.block2.item11',
          img: require('@/assets/img/products-services/cross-border/10.png'),
          row1: {
            available: false
          },
          row2: {
            available: false
          },
          row3: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg')
            ],
            available: true,
            local: false,
            international: true
          },
          row4: {
            available: false
          },
          row5: {
            imgs: [
              require('@/assets/img/products-services/cross-border/payments/safe.svg')
            ],
            available: true,
            local: false,
            international: true
          }
        }
      ]
    }
  },
  head () {
    return {
      title: this.$t('footer.products-services.cross-border').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy () {
    clearTimeout(this.interval)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize () {
      clearTimeout(this.interval)
      this.interval = setTimeout(() => {
        this.windowWidth = window.innerWidth
        this.isLargeScreen = window.matchMedia('(min-width: 1024px)').matches
      }, 500)
    },
    changeCountry ($event, index) {
      this.hide = true
      setTimeout((that = this) => {
        that.activeItem = index - 1
        that.hide = false
      }, 400)
    }
  }
}
